




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
@Component({
  name: 'CurrentDisciplinesSpecialities',
  components: {},
})
export default class CurrentDisciplinesSpecialities extends Vue {
  @Prop() disciplines;
  @Prop() onDelete;
  @Prop() viewMode;

  userPermissionConfig(permission){
    return vxm.configs.getUserPermissionConfig(permission,'SKILLS');
  }
}
